import React, { Component } from 'react'
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
    Typography,
    Box,
    Tabs,
    Grid,
    FormControl,
    FormControlLabel,
    Checkbox,
    MenuItem,
} from '@mui/material'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/pro-duotone-svg-icons'

import LoadingDefault from '../Elements/Loading/LoadingDefault'
import LocaleName from '../Elements/Translations/LocaleName'

import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
import { StyledVerticalTab } from '@/Components/Elements/StyledComponents/Tabs'
import TabPanel from '@/Components/Elements/TabPanel/TabPanel'
class AddDisplayByDataFieldModal extends Component {
    constructor(props) {
        super(props)
        let locales = this.props.kedo.env().getEnvironmentLocales()
        let translations = []
        locales.map((localeItem) => {
            translations.push({
                culture: localeItem.code,
                name: this.props.item.name,
            })
        })

        this.state = {
            defDossier: this.props.item.defDossier,
            environment: this.props.item.environment,
            dataFieldUuid: this.props.item.uuid,
            views: [],
            errors: false,
            submitting: false,
            displayPositions: [],
            translations: translations,
            dataField: this.props.dataField,
            displayItems: [],
            activeTab: 'first',
        }

        this.submit = this.submit.bind(this)
        this.fetchDisplayPositions = this.fetchDisplayPositions.bind(this)
        this.fetchDisplayItems = this.fetchDisplayItems.bind(this)
        this.onChangeAddDisplay = this.onChangeAddDisplay.bind(this)
    }

    fetchDisplayPositions() {
        let url =
            this.props.kedo.api().getDisplayPositionEndpoint() +
            '?limit=500&defDossier=' +
            this.state.defDossier
        this.setState({ fetchingPositions: true })
        this.props.kedo
            .api()
            .getCached(url)
            .then((response) =>
                this.setState({
                    displayPositions: response.data.results,
                    fetchingPositions: false,
                })
            )
    }

    fetchDisplayItems(callBack) {
        let url =
            this.props.kedo.api().getDisplayItemEndpoint() +
            '?limit=500&defDossier=' +
            this.state.defDossier
        this.props.kedo
            .api()
            .getCached(url)
            .then((response) =>
                this.setState(
                    {
                        displayItems: response.data.results,
                    },
                    callBack
                )
            )
    }

    onChangeAddDisplay(e) {
        let views = this.state.views.filter((item) => item !== e.target.value)
        if (e.target.checked) {
            views.push(e.target.value)
        }
        this.setState({ views: views })
    }

    compareItem(item, view) {
        if (
            view === 'edit' &&
            (item.view === 'edit' || item.view === 'show/edit')
        ) {
            return true
        }

        if (
            view === 'show/edit' &&
            (item.view === 'edit' ||
                item.view === 'show' ||
                item.view === 'show/edit')
        ) {
            return true
        }

        if (
            view === 'show' &&
            (item.view === 'show' || item.view === 'show/edit')
        ) {
            return true
        }

        return item.view === view
    }

    submit() {
        let api = this.props.kedo.api()
        let totLength = this.state.views.length
        if (totLength > 0) {
            this.setState({ submitting: true })
        }

        this.fetchDisplayItems()

        this.state.views.map((viewName, vIndex) => {
            let data = {
                defDossier: this.state.defDossier,
                environment: this.state.environment,
                defDossierDefField: this.state.dataFieldUuid,
                rank: 1,
                col: 1,
                rowspan: 12,
                colspan: 4,
                translations: this.state.translations,
                view: viewName,
            }

            let latestRow = 1
            this.state.displayItems
                .filter((item) => this.compareItem(item, viewName))
                .map((item) =>
                    item.rank > latestRow ? (latestRow = item.rank) : null
                )

            data.rank = latestRow + 1

            if (viewName == 'show/edit') {
                data.displayPosition = this.state.displayPosition
            }

            api.post(api.getDisplayItemEndpoint(), data).then((response) => {
                if (vIndex + 1 >= totLength) {
                    this.props.onClose()
                }
            })
        })
    }

    componentDidMount() {
        this.fetchDisplayPositions()
    }

    onChangeTranslation(locale, ddiName) {
        let trans = this.state.translations.find(
            (item) => item.culture === locale
        )
        let translations = this.state.translations.filter(
            (item) => item.culture !== locale
        )

        if (!trans) {
            trans = { culture: locale, name: ddiName }
        } else {
            trans.name = ddiName
        }
        translations.push(trans)

        this.setState({ translations: translations })
    }

    renderTranslations(translations) {
        const kedo = this.props.kedo
        if (!translations || translations.length <= 0) {
            translations = []
        }
        let locales = this.props.kedo.env().getEnvironmentLocales()

        if (!locales) {
            return this.props.kedo.t('No languages set')
        }

        if (locales.length === 1) {
            let trans = translations.find(
                (item) => locales[0].code === item.culture
            )
            if (!trans) {
                trans = {}
            }

            return (
                <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        {kedo.t('Name')}
                    </Typography>

                    <TextField
                        fullWidth
                        size="small"
                        value={trans.name || ''}
                        error={!!this.state.errors[locales[0]]}
                        onChange={(event) =>
                            this.onChangeTranslation(
                                locales[0].code,
                                event.target.value
                            )
                        }
                    />
                </Box>
            )
        }

        return (
            <Box className="language_accordion">
                {locales.map((locale) => {
                    let trans = translations.find(
                        (item) => locale.code === item.culture
                    )

                    if (!trans) {
                        trans = {}
                    }

                    return (
                        <Accordion
                            key={locale.id}
                            defaultExpanded={locale.id === locales[0].id}
                        >
                            <AccordionSummary
                                expandIcon={
                                    <FontAwesomeIcon icon={faAngleDown} />
                                }
                            >
                                <LocaleName
                                    kedo={kedo}
                                    localeCode={locale.code}
                                />
                            </AccordionSummary>

                            <AccordionDetails>
                                <Box sx={{ mb: 2 }}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{ mb: 1 }}
                                    >
                                        {this.props.kedo.t('Name')}
                                    </Typography>

                                    <TextField
                                        fullWidth
                                        size="small"
                                        value={trans.name || ''}
                                        error={!!this.state.errors[locale]}
                                        onChange={(event) =>
                                            this.onChangeTranslation(
                                                locale.code,
                                                event.target.value
                                            )
                                        }
                                    />
                                </Box>

                                <Box sx={{ mb: 2 }}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{ mb: 1 }}
                                    >
                                        {this.props.kedo.t('Information text')}
                                    </Typography>

                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={3}
                                        value={
                                            trans.settings &&
                                            trans.settings.informationtext
                                                ? trans.settings.informationtext
                                                : ''
                                        }
                                        onChange={(event) =>
                                            this.onChangeTranslationSettings(
                                                locale.code,
                                                event.target.value,
                                                'informationtext'
                                            )
                                        }
                                    />
                                </Box>

                                <Box sx={{ mb: 2 }}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{ mb: 1 }}
                                    >
                                        {this.props.kedo.t('Pre text')}
                                    </Typography>

                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={3}
                                        value={
                                            trans.settings &&
                                            trans.settings.pretext
                                                ? trans.settings.pretext
                                                : ''
                                        }
                                        onChange={(event) =>
                                            this.onChangeTranslationSettings(
                                                locale.code,
                                                event.target.value,
                                                'pretext'
                                            )
                                        }
                                    />
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    )
                })}
            </Box>
        )
    }

    render() {
        const kedo = this.props.kedo

        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'md'}
                fullWidth
                title={kedo.t('Add display items?')}
                onClose={() => this.setState({ showFilter: false })}
                contentProps={{ dividers: true, dense: true }}
                actions={
                    <>
                        <StyledButton
                            disabled={this.state.submitting}
                            onClick={this.submit}
                        >
                            {this.state.submitting ? <LoadingDefault /> : null}{' '}
                            {kedo.t('Yes')}
                        </StyledButton>
                        <StyledButton
                            disabled={this.state.submitting}
                            onClick={this.props.onClose}
                            color="secondary"
                        >
                            {kedo.t('No')}
                        </StyledButton>
                    </>
                }
            >
                <Grid container>
                    <Grid
                        size={{ sm: 3 }}
                        sx={{ borderRight: 1, borderColor: 'divider' }}
                    >
                        <Tabs
                            orientation="vertical"
                            sx={{
                                '& .MuiTabs-indicator': { display: 'none' },
                            }}
                            value={this.state.activeTab}
                            onChange={(event, newValue) =>
                                this.setState({ activeTab: newValue })
                            }
                        >
                            <StyledVerticalTab
                                value="first"
                                label={kedo.t('General')}
                            />

                            <StyledVerticalTab
                                value="labels"
                                label={kedo.t('Labels')}
                            />
                        </Tabs>
                    </Grid>
                    <Grid size={{ sm: 9 }}>
                        <TabPanel value={this.state.activeTab} index="first">
                            <Typography>
                                {kedo.t(
                                    'What display items do you want to auto create?'
                                )}
                            </Typography>
                            <Box component="form">
                                <FormControl fullWidth margin="normal">
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            mb: 1,
                                            fontWeight: 'bold',
                                            fontSize: '0.875rem',
                                            color: 'text.primary',
                                        }}
                                    >
                                        {kedo.t('Type')}
                                    </Typography>

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                size="small"
                                                onChange={
                                                    this.onChangeAddDisplay
                                                }
                                                value={'list'}
                                            />
                                        }
                                        label={kedo.t('List')}
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                size="small"
                                                onChange={
                                                    this.onChangeAddDisplay
                                                }
                                                value={'summary'}
                                            />
                                        }
                                        label={kedo.t('Summary')}
                                    />
                                </FormControl>
                                <FormControl fullWidth margin="normal">
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            mb: 1,
                                            fontWeight: 'bold',
                                            fontSize: '0.875rem',
                                            color: 'text.primary',
                                        }}
                                    >
                                        {kedo.t('Location')}
                                        {this.state.fetchingPositions ? (
                                            <LoadingDefault />
                                        ) : null}
                                    </Typography>

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={
                                                    this.onChangeAddDisplay
                                                }
                                                value={'show/edit'}
                                            />
                                        }
                                        label={kedo.t('Show/edit')}
                                    />

                                    <TextField
                                        select
                                        name={'displayPosition'}
                                        size="small"
                                        onChange={(e) =>
                                            this.setState({
                                                [e.target.name]: e.target.value,
                                            })
                                        }
                                    >
                                        <MenuItem value="">
                                            {this.props.kedo.t(
                                                'Choose an option'
                                            )}
                                        </MenuItem>

                                        {this.state.displayPositions.map(
                                            (item) => (
                                                <MenuItem
                                                    key={item.id}
                                                    value={item.id}
                                                >
                                                    {item.name_plural}
                                                </MenuItem>
                                            )
                                        )}
                                    </TextField>
                                </FormControl>
                                <FormControl fullWidth margin="normal">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                size="small"
                                                onChange={
                                                    this.onChangeAddDisplay
                                                }
                                                value={'search'}
                                            />
                                        }
                                        label={kedo.t('Search')}
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                size="small"
                                                onChange={
                                                    this.onChangeAddDisplay
                                                }
                                                value={'advanced-search'}
                                            />
                                        }
                                        label={kedo.t('Advanced search')}
                                    />
                                </FormControl>
                            </Box>
                        </TabPanel>
                        <TabPanel value={this.state.activeTab} index="labels">
                            {this.renderTranslations(this.state.translations)}
                        </TabPanel>
                    </Grid>
                </Grid>
            </AppDialog>
        )
    }
}

export default AddDisplayByDataFieldModal
